module.exports = __webpack_public_path__ + "static/media/sans-rival.aa524e0a.jpg";